module.exports = __webpack_public_path__ + "static/media/co.22da0f07.svg";